export const getTeamColor = (teamTagName) => {
  if (teamTagName === "UX/UI") {
    return "var(--blue-600)"
  } else if (teamTagName === "DEVS") {
    return "var(--cyan-600)"
  } else if (teamTagName === "ADMIN" || teamTagName === "LEADS") {
    return "var(--orange-500)"
  } else {
    return "var(--secondary-color)"
  }
}
